/* Fill the grid cell so the upload card matches the connection card height (PageGridRow stretch). */
.uploadCardFill {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;

  & > * {
    flex: 1;
    min-height: 0;
  }
}
